"use strict";
/**
 * Traps tab focus inside an active element, like a modal or dropdown
 *
 * @link https://uxdesign.cc/how-to-trap-focus-inside-modal-to-make-it-ada-compliant-6a50f9a70700
 *
 * @param {String} id - The id of the element, set as a string
 */
function trapFocus(id) {
    // add all the elements inside element which you want to make focusable
    const focusableElements = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="search"]:not([disabled]), input[type="submit"]:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const element = document.querySelector(id); // select the element by it's id
    const firstFocusableElement = element === null || element === void 0 ? void 0 : element.querySelectorAll(focusableElements)[0]; // get first focusable item in element
    const focusableContent = element === null || element === void 0 ? void 0 : element.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent
        ? focusableContent[focusableContent.length - 1]
        : undefined; // get last focusable item in element
    document.addEventListener("keydown", function (e) {
        let isTabPressed = e.key === "Tab" || e.keyCode === 9;
        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) {
            // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement === null || lastFocusableElement === void 0 ? void 0 : lastFocusableElement.focus(); // add focus for the last focusable item
                e.preventDefault();
            }
        }
        else {
            // if tab key is pressed
            if (document.activeElement === lastFocusableElement) {
                // if focused has reached to last focusable item then focus first focusable item after pressing tab
                firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus(); // add focus for the first focusable item
                e.preventDefault();
            }
        }
    });
    firstFocusableElement.focus();
}
trapFocus("#dropdownLogin");
